import { render, staticRenderFns } from "./MiddleTop.vue?vue&type=template&id=385d137e&scoped=true"
import script from "./MiddleTop.vue?vue&type=script&lang=js"
export * from "./MiddleTop.vue?vue&type=script&lang=js"
import style0 from "./MiddleTop.vue?vue&type=style&index=0&id=385d137e&prod&lang=scss"
import style1 from "./MiddleTop.vue?vue&type=style&index=1&id=385d137e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d137e",
  null
  
)

export default component.exports